export interface OrganisationCustomIdentifier {
  id: string;
  organisation_id: string;
  name: string;
  maps_to: string | null;
  created_at: string;
  created_by: string | null;
}

export interface OrganisationCustomIdentifierAudit {
  id: string;
  organisation_id: string;
  actor_id: string | null;
  actor_email: string | null;
  operation: 'create' | 'update';
  identifier_name: string;
  created_at: string;
}

export const IDENTIFIER_CONFIG_INVALID_INPUT = '/errors/identifier-config/invalid-input';
export const IDENTIFIER_CONFIG_NO_USABLE_HEADERS = '/errors/identifier-config/no-usable-headers';
export const INVENTORY_UPLOAD_NO_SUPPORTED_IDENTIFIER =
  '/errors/inventory-upload/no-supported-identifier';
